import React, { ReactNode, useContext, useEffect } from 'react';
import { Slice } from 'gatsby';
import { RouteComponentProps, useLocation } from '@gatsbyjs/reach-router';
import { Header } from '../header';
import IsiFooter from '../isi';
import CookieBanner from '../cookie-banner';
import context from '../../context/product/context';
import { enrollmentContext } from '../../context/enrollment/enrollment-context';
import { EventCategory, EventKeys } from '../../../../services/ga';
import AnalyticsFactory from '../../../../services/analytics-factory';

export interface LayoutProps extends RouteComponentProps {
	label?: string;
	header?: boolean;
	footer?: boolean;
	mlrVersion?: string;
	children: ReactNode;
}

export const MainLayout: React.FC<LayoutProps> = ({
	children,
	label = '',
	header = true,
	footer = true,
	mlrVersion,
}) => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const { pathname, href } = useLocation();
	enrollmentCtxt.serviceDisclaimers = new Set();
	const analytics = AnalyticsFactory.createAnalytics('ga');

	useEffect(() => {
		analytics.sendEvent({
			[EventKeys.Event]: EventCategory.UAPageview,
			[EventKeys.PageTitle]: label,
			[EventKeys.PageURL]: href,
			[EventKeys.PageRespondTime]: new Date().getTime(),
		});
	}, [pathname]);

	return (
		<>
			{header && <Header />}
			<main className="text-font">{children}</main>
			{footer && (
				<>
					<IsiFooter>
						<Slice
							alias="footer"
							mlrVersion={mlrVersion as string}
							config={ctxt.json.footer}
							socialNetworks={ctxt.json.socialNetworks}
							disclaimers={enrollmentCtxt.serviceDisclaimers}
						/>
					</IsiFooter>
					{ctxt.json.pages.cookies && <CookieBanner />}
				</>
			)}
		</>
	);
};
